import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

import ViewContainer from "components/ViewContainer/ViewContainer";
import { sendPasswordResetToken } from "services/http/users";

const PasswordResetToken = (props) => {
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [responseText, setResponseText] = useState();

  const { enqueueSnackbar } = props;
  const { t } = useTranslation();

  const handleSendToken = useCallback(
    (token) => {
      const request = {
        data: {
          token: token,
        },
      };

      sendPasswordResetToken(request).then(
        (_response) => {
          setResponseText(t("Uusi salasana on lähetetty sähköpostiisi"));
          enqueueSnackbar(t("Onnistui"), { variant: "success" });
          setLoading(false);
        },
        (_error) => {
          setResponseText(t("Salasanan nollaus epäonnistui"));
          enqueueSnackbar(t("Epäonnistui"), { variant: "error" });
          setLoading(false);
        },
      );
    },
    [enqueueSnackbar, t],
  );

  useEffect(() => {
    if (!search) {
      setResponseText(t("Virheellinen tai puuttuva palautuslinkki"));
      setLoading(false);
      return;
    }
    const parsed = queryString.parse(search);
    if (parsed.token) {
      handleSendToken(parsed.token);
    } else {
      setResponseText(t("Virheellinen tai puuttuva palautuslinkki"));
      setLoading(false);
    }
  }, [search, handleSendToken, t]);

  return (
    <ViewContainer title={t("Vahvistetaan salasanan palautus")}>
      <Grid
        container
        direction="row"
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <Grid size={12}>
          {loading ? (
            <CircularProgress />
          ) : (
            <Typography>{responseText}</Typography>
          )}
        </Grid>
      </Grid>
    </ViewContainer>
  );
};

export default PasswordResetToken;
